// extracted by mini-css-extract-plugin
export var buttonsContainerCustom = "SocialFollowButtons-module--buttonsContainerCustom--09a0f";
export var facebookCustom = "SocialFollowButtons-module--facebookCustom--f751c";
export var instagramCustom = "SocialFollowButtons-module--instagramCustom--76af4";
export var pinterestCustom = "SocialFollowButtons-module--pinterestCustom--8126e";
export var seperatedCustom = "SocialFollowButtons-module--seperatedCustom--7f8f0";
export var socialFollowButtonContainerCustom = "SocialFollowButtons-module--socialFollowButtonContainerCustom--03d02";
export var socialMediaLinkCustom = "SocialFollowButtons-module--socialMediaLinkCustom--793f6";
export var tagCustom = "SocialFollowButtons-module--tagCustom--1fbc3";
export var tagsContainerCustom = "SocialFollowButtons-module--tagsContainerCustom--a27cf";
export var twitterCustom = "SocialFollowButtons-module--twitterCustom--00476";
export var youtubeCustom = "SocialFollowButtons-module--youtubeCustom--197c9";